const constants = {
  LOGOUT: 'LOGOUT',
  SET_TOKEN: 'SET_TOKEN',
  SET_USER: 'SET_USER',
};

export default constants;


// WEBPACK FOOTER //
// ./src/store/constants.js